import "@/App.css";
import "./pages-content.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Profile from "./pages/Profile";
import Dashboard from "./pages/Dashboard";
import Studio from "./pages/Studio";
import Output from "./pages/Output";
import Operator from "./pages/Operator";
import Admin from "./pages/Admin";
import PageEditor from "./pages/PageEditor";
import PublicPage from "./pages/PublicPage";
import PlansUpgrade from "./pages/PlansUpgrade";

function Loader() {
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-background">
      <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/studio/:id" element={<Protected><Studio /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/admin/pages/:id" element={<Protected><PageEditor /></Protected>} />
      <Route path="/planos" element={<Protected><PlansUpgrade /></Protected>} />
      <Route path="/live/:id" element={<Output />} />
      <Route path="/operator/:id" element={<Operator />} />
      <Route path="/:slug" element={<PublicPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-right" theme="dark" />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
